function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var HomeFilled = function HomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M15.805 22.868h4.852a2.375 2.375 0 0 0 2.38-2.363v-7.848a6.47 6.47 0 0 0-2.098-4.754l-6.496-5.955a3.66 3.66 0 0 0-4.927.011L3.079 7.91a6.47 6.47 0 0 0-2.08 4.735v7.861a2.375 2.375 0 0 0 2.38 2.363h4.844c.817 0 1.488-.663 1.495-1.478l.03-3.645h4.547l.014 3.64a1.495 1.495 0 0 0 1.496 1.483"
  }));
};
export default HomeFilled;